import React, { useEffect } from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import fr from 'facet-rest';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { RightColumnProvider } from 'Context/RightColumnContext';
import {
  RoadmapExecutiveSummaryContent,
} from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryTemplate/RoadmapExecutiveSummary/RoadmapExecutiveSummaryContent';
import {
  SelectScenarioContextProvider,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

export const RoadmapExecutiveSummaryTemplate = ({ resource }) => {
  const { loadModalCollectionByLink } = useModalContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const proposalExpirationRel = resource.withRelationship(
    fr.relationships.proposalExpiration.name,
    (rel) => rel,
    () => null,
  );

  useEffect(() => {
    logStandardizedEvent(categories.clientWhatIf, eventTypes.navigateTo, 'Navigated to Roadmap Executive Summary Page');
  }, []);

  useEffect(() => {
    if (proposalExpirationRel) {
      loadModalCollectionByLink(proposalExpirationRel.link('related').url());
    }
  }, [proposalExpirationRel]);

  useComponentDidMount(() => {
    resource.withRelationship(
      fr.relationships.markProposalViewed.name,
      async (rel) => {
        const [resourceToSubmit] = await rel.link('related').get();
        await resourceToSubmit.submit();
      },
      () => null,
    );
  });

  const { loadPageContentLink } = usePageContentContext();

  const onSelectSuccess = async () => {
    // After we submit the scenario successfully we need to make sure we get taken into the scenario wizard.
    // We will take you to the decision step which will then direct you to the correct place
    await resource.withRelationship(fr.relationships.scenarioSelectionDecisionStep.name,
      (decisionStepRel) => loadPageContentLink(decisionStepRel.link('related')),
      () => null);
  };

  return (
    <SelectScenarioContextProvider onSelectSuccess={onSelectSuccess}>
      <RightColumnProvider>
        <RoadmapExecutiveSummaryContent resource={resource} />
      </RightColumnProvider>
    </SelectScenarioContextProvider>
  );
};
